import { useRef, useMemo } from 'react';

const MESSAGES = {
  courses: { up: '\uD83D\uDFE2 New Course Added', down: '\uD83D\uDD3B Course Removed' },
  placements: { up: '\uD83D\uDFE2 New Placement Added', down: '\uD83D\uDD3B Placement Deleted' },
  partners: { up: '\uD83D\uDFE2 New Partner Registered', down: null },
  issues: { up: '\uD83D\uDD34 New Issue Created', down: null },
  users: { up: '\uD83D\uDD35 New User Registered', down: '\uD83D\uDD3B User Removed' },
};

export function useCountChangeDetector(counts) {
  const prevRef = useRef(null);
  const readyRef = useRef(false);

  const changes = useMemo(() => {
    if (prevRef.current === null) {
      prevRef.current = { ...counts };
      return {};
    }

    if (!readyRef.current) {
      readyRef.current = true;
      prevRef.current = { ...counts };
      return {};
    }

    const result = {};
    for (const key of Object.keys(counts)) {
      const prev = prevRef.current[key];
      const curr = counts[key];
      if (prev !== undefined && curr !== undefined && prev !== curr) {
        const increased = curr > prev;
        const msgCfg = MESSAGES[key];
        const message = increased ? msgCfg?.up : msgCfg?.down;
        if (message) {
          result[key] = {
            message,
            increased,
            previous: prev,
            current: curr,
            changeKey: `${prev}-${curr}-${Date.now()}`,
          };
        }
      }
    }
    prevRef.current = { ...counts };
    return result;
  }, [counts]);

  return changes;
}